import React from "react";
import {useTranslation} from "react-i18next";
// local
import {Modal} from "components/Modal";
import {ButtonTransparent} from "components/buttons/ButtonTransparent";
import ProjectsSelect from "components/selects/ProjectsSelect";
import {IconFileAdd, IconCopy, IconChevronDown} from "components/icons/index";
import {color} from "constants/color.consts";

export const ProcurementPlaceProjectModal = ({
  projects,
  selectedProject,
  onSelectProject,
  procurement,
  loading,
  onCreateInNewProject,
  onCreateInExitingProject,
  loggedUser,
  onClose,
}) => {
  const {t} = useTranslation();

  const rfpName = procurement?.Request?.name || "";

  const onChangeProject = (id) =>
    onSelectProject(projects.find((item) => item.id === id));

  return (
    <Modal
      noTitleIcon
      boldTitle
      titleText={t("PROCUREMENT_PLACE_PROJECT_MODAL_TITLE").format(rfpName)}
      rounded
      placeBitLow
      style={{marginTop: "15vh"}}
      width="630"
      onClose={onClose}
    >
      <div className="pa-8">
        <div className="fz-16 mb-8">
          {t("PROCUREMENT_PLACE_PROJECT_MODAL_DESCRIPTION")}
        </div>
        <div className="df-row-jcc-center">
          <div className="rfp-create-modal_create-block wdthp-50">
            <span className="fz-10 __uppercase __bold">
              {t("PROCUREMENT_PLACE_PROJECT_MODAL_CREATE_LABEL")}
            </span>
            <div className="rfp-create-modal_create-block_data hght-110">
              <ButtonTransparent
                name="PROCUREMENT_PLACE_PROJECT_MODAL_CREATE_BUTTON"
                icon={<IconFileAdd />}
                nonTransparent
                fullWidth
                color="green"
                addClass="rfp-create-modal_create-block_button"
                onClick={onCreateInNewProject}
                disabled={loading}
              />
            </div>
          </div>
          {!!projects?.length && (
            <div className="rfp-create-modal_create-block ml-8 wdthp-50">
              <span className="fz-10 __uppercase __bold">
                {t("PROCUREMENT_PLACE_PROJECT_MODAL_INSERT_LABEL")}
              </span>
              <div className="rfp-create-modal_create-block_data hght-110">
                <ProjectsSelect
                  list={projects}
                  needSearch={true}
                  onChange={onChangeProject}
                  highlightMyProjectsId={loggedUser.id}
                  noBorder
                  fullWidth
                  large
                  customIcon={<IconChevronDown color={color.purple} />}
                  addClass="mb-1"
                  selectedValue={selectedProject?.id}
                />

                <ButtonTransparent
                  name="PROCUREMENT_PLACE_PROJECT_MODAL_INSERT_BUTTON"
                  icon={<IconCopy color={color.white} />}
                  disabled={loading}
                  nonTransparent
                  fullWidth
                  onClick={() => onCreateInExitingProject(selectedProject)}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};
